export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";